import { Component, SimpleChanges } from '@angular/core';
import {EventEmitter} from '@angular/core';
import {Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'pagination',
    templateUrl: 'pagination.component.html',
    styleUrls: ['pagination.component.scss']
})
export class PaginationComponent implements OnInit {

    @Input()
    count: number;

    private _page: number;

    @Input()
    get page(): number {
        return this._page;
    }

    set page(page: number) {
        if (this._page !== page) {
            this._page = page;
            this.pageChange.emit(page);
        }
    }

    @Output()
    pageChange: EventEmitter<number> = new EventEmitter<number>();

    pages: number[];

    pagesCount: number;

    @Input()
    step: number;

    ngOnInit(): void {
        this.count = +this.count;
        this.page = +this.page;
        this.step = +this.step;
        this.pagesCount = Math.ceil(this.count / this.step);
        this.pages = this._generatePages();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['count']) {
            this._setPagesCount();
            this.pages = this._generatePages();
        }
    }

    private _setPagesCount() {
        this.pagesCount = Math.ceil(this.count / this.step);
    }

    isPage(page: number): boolean {
        return (this.page === page);
    }

    setPage(page: number): void {
        if (page !== this.page && page >= 1 && page <= this.pagesCount) {
            this.page = page;
            this.pages = this._generatePages();
        }
    }

    private _generatePages(): number[] {
        const pages = [];
        if (this.pagesCount > 1) {
            if (this.pagesCount < 10) {
                for (let i = 0; i < this.pagesCount; i++) {
                    pages.push(i + 1);
                }
            } else {
                pages.push(1);
                if (this.page < 5) {
                    pages.push(2, 3, 4, 5);
                }
                pages.push(null);
                if (this.page + 5 > this.pagesCount) {
                    pages.push(this.pagesCount - 4, this.pagesCount - 3, this.pagesCount - 2, this.pagesCount - 1);
                } else if (this.page > 4) {
                    pages.push(this.page - 1, this.page, this.page + 1, null);
                }
                pages.push(this.pagesCount);
            }
        }
        return pages;
    }

}
